import React, { useEffect, useRef, useState } from "react";
import VariableTextCell from "./VariableTextCell";

const LoadingAnimation = () => {

  const [character, setCharacter] = useState (null);

  useEffect(() => {
    const grid = document.querySelector("#loading_grid");
    const nRows = 3;

    const animateGrid = () => {
      grid.style.gridTemplateColumns = getRandomRows(nRows);
      grid.style.gridTemplateRows = getRandomRows(nRows);
    };

    const interval = setInterval(animateGrid, 1000);

    return () => clearInterval(interval);
  }, []);

  const getRandomRows = (n) => {
    let styleString = "";

    for (let i = 0; i < n; i++) {
      const randomNumber = Math.floor(Math.random() * 4) + 1;
      styleString += " " + randomNumber + "fr";
    }

    return styleString;
  };

  return (
    <div id="loading_grid">
      <div className="big"></div>
      <div className="small">
      </div>
    </div>
  );
};

export default LoadingAnimation;
